import React, { Component } from "react";
import Strings from "@my-dld/assets/strings";
import Dropzone from "react-dropzone";
import DocumentInputField from "../Form/DocumentInputField";
import { RVSDocument } from "@eres/rvsapi/entities";
import { getRVSDocName, getRVSDocSize, getRVSDocType, RVSDocTypes } from "@my-dld/utils/RVSUtils";
import { isEmptyStringOrNull } from "@eres/core/dist/StringUtils";

interface Props {

}

export interface DocumentDetailsState {
	docs: RVSDocument[];
}

interface State extends DocumentDetailsState {
	errorMsg?: string;
}

class DocumentDetails extends Component<Props, State> {
	constructor( props: Props ) {
		super( props );
		this.state = {
			docs: [],
		};
	}

	render() {
		const { docs, errorMsg } = this.state;
		return <div className="card" id="DocumentDetails">
			<div className="card-header">
				<span>{ "5 - " + Strings.documents }</span>
			</div>
			<div className="card-body">
				<div className="row">
					<div className="col-md-12 font-weight-bold mb-3">{ Strings.upload_documents }
						<span className="d-flex">
                            <small>{ Strings.tabu_upload_documents_note }</small>
                        </span>
					</div>
					<div className="col-md-12">
						{ errorMsg && <div className="alert alert-danger">{ errorMsg }</div> }
					</div>
					<div className="col-md-12">
						<Dropzone
							multiple={ true }
							maxSize={ 2 * 1024 * 1000 }
							onDropRejected={ this.onDropRejected }
							onDrop={ this.onDrop }
							accept={ [ "image/png", "image/jpeg", "application/pdf" ] }>
							{ ( { getRootProps, getInputProps } ) => (
								<DocumentInputField { ...getRootProps() }
								                    dropZoneInputProps={ getInputProps() }
								                    label={ "" }/>
							) }
						</Dropzone>
						{ docs.map( ( doc: RVSDocument, index: number ) => {
							return <RenderUploadDoc
								key={ "rvs_doc_" + index } doc={ doc }
								onDelete={ () => this.onDelete( index ) }/>;
						} ) }
					</div>
				</div>
			</div>
		</div>;
	}

	public isValid(): Promise<DocumentDetailsState> {
		const { docs } = this.state;
		if ( docs && docs.length > 0 ) {
			return Promise.resolve( this.state );
		}
		this.setState( {
			errorMsg: Strings.rvs_docs_validation,
		} );
		return Promise.reject( "DocumentDetails not Valid" );
	}

	public reset() {
		this.setState( {
			docs: [],
			errorMsg: undefined,
		} );
	}

	private onDropRejected = () => {
		this.setState( {
			errorMsg: Strings.tabu_file_exceed_size,
		} );
	};

	private onDrop = ( files: File[] ) => {
		files.filter( x => x.type.startsWith( "image/" ) || x.type.startsWith( "application/pdf" ) )
		.forEach( file => this.addFile( file ) );
	};

	private addFile( file: File ) {
		const reader = new FileReader();
		reader.onload = () => {
			const binaryStr = reader.result;
			const attachedDoc: RVSDocument = {
				localFile: file,
				localData: binaryStr as string,
				fileName: file.name,
				fileSize: file.size,
				type: file.type,
			};
			this.setState( {
				errorMsg: undefined,
				docs: this.state.docs.concat( attachedDoc ),
			} );
		};
		reader.readAsDataURL( file );
	}

	private onDelete = ( index: any ) => {
		const { docs } = this.state;
		docs.splice( index, 1 );
		this.setState( {
			docs: docs,
		} );
	};
}

export function RenderUploadDoc( props: { doc: RVSDocument, onDelete: () => void } ) {
	const { doc, onDelete } = props;
	let docType = getRVSDocType( doc );
	let preview = ( docType === RVSDocTypes.PDF ) ? <i className="far fa-file-pdf"/> : getImagePreview( doc );
	return <div className={ "mb-2 table-responsive" }>
		<table className="table table-bordered table-condensed table-striped table-responsive-sm upload-table">
			<thead>
			<tr>
				<th>{ Strings.file }</th>
				<th>{ Strings.name }</th>
				<th>{ Strings.size }</th>
				<th>{ Strings.vid_date }</th>
				<th>{ Strings.action }</th>
			</tr>
			</thead>
			<tbody>
			<tr>
				<td data-label={ Strings.file }>{ preview }</td>
				<td data-label={ Strings.name }>{ getRVSDocName( doc ) }</td>
				<td data-label={ Strings.size }>{ getRVSDocSize( doc ) + " " + Strings.size_mb }</td>
				<td data-label={ Strings.action }>{ getRVSDocType( doc ) }</td>
				<td>
					<button className="btn btn-grey" onClick={ onDelete }>
						<i className="far fa-trash-alt"/>{ Strings.delete }
					</button>
				</td>
			</tr>
			</tbody>
		</table>
	</div>;
}

export function getImagePreview( doc: RVSDocument ) {
	let source = ( doc.localData && !isEmptyStringOrNull( doc.localData ) ) ?
		doc.localData : ( ( doc.remoteDoc && !isEmptyStringOrNull( doc.remoteDoc.DocumentUrl ) ) ?
			doc.remoteDoc.DocumentUrl : "" );
	return <img src={ source } style={ { height: 40, width: 40 } } alt={ "uploaded_image" }/>;
}

export default DocumentDetails;
